/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-03 16:11:48
 **/
/* eslint-disable @typescript-eslint/no-unused-vars */

import { useEffect, useState } from "react";
import { Column } from "@/frameworks/designStuff/components";
import { useTimeout } from "@/frameworks/libraries/utilities";
import { usePhoneCall } from "@/frameworks/core/hooks";
import { DialingState } from "@/frameworks/core/components";
import DialButton from "./DialButton";

export type DialCommandsProps = {
	callID: string;
	disabled?: boolean;
	isBlockedByMe?: boolean;
} & Partial<WebServices.People.List.User>;

const LOGTAG = "#DialPad#";

export default function DialPad(props: DialCommandsProps) {
	const { callID } = props;
	const [isCallEnded, setCallEnded] = useState(false);
	const {
		state: { status }
	} = usePhoneCall();
	const callStatus = status(callID)[0];
	const timer = useTimeout();

	useEffect(() => {
		if (callStatus === "END") {
			setCallEnded(true);
		}
	}, [callStatus]);

	useEffect(() => {
		if (isCallEnded) {
			timer.start(2000, () => {
				setCallEnded(false);
			});
		}
	}, [isCallEnded]);

	return (
		<>
			<DialingState {...props} isCallEnded={isCallEnded} />
			<DialButton {...props} isCallEnded={isCallEnded} />
		</>
	);
}
